export default __webpack_public_path__ + "static/media/036-hippopotamus.9ebc9392.svg";